module.exports = __webpack_public_path__ + "img/teach4.62d77f82.jpg";